/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Collapse, Switch, Tag } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CaretRightOutlined } from "@ant-design/icons";
import { PlusIcon } from "../../../../../../atoms/CustomIcons";
import SubServiceTable from "../SubServiceTable";
import EmptyCard from "../../../../../../atoms/EmptyCard";

export default function CollapseSubService(props: any) {
  const { data, setActiveRecord, setActiveType } = props;
  const navigate = useNavigate();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];
  const [subArchived, isSubArchived] = useState(false);

  const onChange = (checked: boolean) => {
    isSubArchived(checked);
  };

  return (
    <Collapse
      items={[
        {
          key: "1",
          label: (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "4px",
                  fontWeight: "700",
                  color: "#151718",
                  paddingLeft: "5px",
                }}
              >
                Subservices
                <Tag
                  style={{
                    minWidth: "20px",
                    height: "22px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    background: "#F2F4F5",
                    border: 0,
                    padding: 0,
                  }}
                >
                  {data?.subservices?.length ?? 0}
                </Tag>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <div className="switchBox">
                  <Switch
                    onChange={onChange}
                    checked={subArchived}
                    onClick={(_checked: boolean, event: any) => {
                      event.stopPropagation();
                    }}
                  />
                  {subArchived ? "Hide archived" : "Show archived"}
                </div>

                <Button
                  onClick={() =>
                    navigate(
                      `/company-settings/${data?.id}/${serviceLineId}/${companyId}`
                    )
                  }
                  icon={<PlusIcon />}
                />
              </div>
            </div>
          ),
          children:
            data?.subservices?.length > 0 ? (
              <div className="subServiceTableWrapper">
                <SubServiceTable
                  data={
                    subArchived
                      ? data?.subservices?.filter(
                          (e: { status: string }) => e?.status === "archived"
                        )
                      : data?.subservices?.filter(
                          (e: { status: string }) => e?.status === "active"
                        )
                  }
                  serviceLineId={serviceLineId}
                  companyId={companyId}
                  parentId={data?.id}
                  setActiveRecord={setActiveRecord}
                  setActiveType={setActiveType}
                  subArchived={subArchived}
                />
              </div>
            ) : (
              <div className="empty_wrap subservice_empty">
                <EmptyCard
                  imageHeight={70}
                  title="No subservices added yet"
                  description="Click the button below to create one."
                  image="/images/empty-icons/no-archived.svg"
                  btnText="Add Subservice"
                  btnLink={`/company-settings/${data?.id}/${serviceLineId}/${companyId}`}
                />
              </div>
            ),
        },
      ]}
      // collapsible={data?.subservices?.length > 0 ? undefined : "disabled"}
      // defaultActiveKey={data?.subservices?.length > 0 ? ["1"] : []}
      defaultActiveKey={["1"]}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
    />
  );
}
